import { Page } from '@/core/architecture'

import { ConsoleFavoriteMemberEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleFavoriteMemberEdit Page
 * 推し編集画面
 */
export const ConsoleFavoriteMemberEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleFavoriteMemberEditTemplate state={state} {...actions} />
}
